export const PIPE_CHOICES = [
    { value: 16, title: 'PE-Xa 16' },
    { value: 17, title: 'PE-Xa 17' },
    { value: 20, title: 'PE-Xa 20' },
    { value: 116, title: 'Pert 16' }
  ];
  
  export const DISTRIBUTION_CHOICES = [
    { value: 1, title: 'Metalic' },
    { value: 2, title: 'Modular cu racord rapid' },
    { value: 3, title: 'Modular cu eurocon' }
  ];
  export const BOX_FOR_DISTRIBUTION_CHOICES = [
    { value: 3, title: 'Nu' },
    { value: 1, title: 'SP' },
    { value: 2, title: 'Sistema' },
  ];
  
  export const AUTOMATION_CHOICES = [
    { value: 1, title: 'Nu' },
    { value: 2, title: 'Da, cu fir' },
    { value: 3, title: 'Da, cu RF' },
    
  ];
  
  export const NO_YES_CHOICES = [
    { value: 1, title: 'Da' },
    { value: 2, title: 'Nu' },
  ];
  
  export const TEMPERATURE_CONTROL_CHOICES = [
    { value: 1, title: 'Nu' },
    { value: 4, title: 'Vana cu 3 cai si pompa 25-80' },
    { value: 7, title: 'Vana cu 4 cai si pompa 25-80' },
  ];
  
  // Dacă vrei codurile asociate
  export const METALLIC_CODES = [
    '304.02.00', '304.03.00', '304.04.00', '304.05.00',
    '304.06.00', '304.07.00', '304.08.00', '304.09.00',
    '304.10.00', '304.11.00', '304.12.00', '304.13.00', '304.14.00'
  ];
  
  export const MONOLITIC_CODES = [
    '303.02.01', '303.03.01', '303.04.01', '303.05.01',
    '303.06.01', '303.07.01', '303.08.01', '303.09.01',
    '303.10.01', '303.11.01', '303.12.01', '303.13.01', '303.14.01'
  ];
  
  export const MODULAR_CODES = [
    '301.02.00', '301.03.00', '301.04.00', '301.05.00',
    '301.06.00', '301.07.00', '301.08.00', '301.09.00',
    '301.10.00', '301.11.00', '301.12.00', '301.13.00',
    '301.14.00', '301.15.00', '301.16.00'
  ];
  
  export const BOX_MAPPING_SISTEMA = {
    '1': '505.08.44',
    '2': '505.02.09',
    '3': '505.03.09',
    '4': '505.04.09',
    '5': '505.05.09',
    '6': '505.06.09'
  };
  
  export const BOX_MAPPING_SP = {
    '1': '505.08.44',
    '2': '505.09.44',
    '3': '505.11.44',
    '4': '505.12.44',
    '5': '505.05.09',
    '6': '505.06.09'
  };
  export const BOX_CALCULATOR = {
    "1": {
      modular: {
        with_control: [],
        no_control: ["301.02.00", "301.03.00"]
      },
      monolithic: {
        with_control: ["303.02.01"],
        no_control: ["303.02.01", "303.03.01"]
      },
      metallic: {
        with_control: ["304.02.00"],
        no_control: ["304.02.00", "304.03.00", "304.04.00"]
      }
    },
    "2": {
      modular: {
        with_control: [],
        no_control: ["301.04.00", "301.05.00", "301.06.00"]
      },
      monolithic: {
        with_control: ["303.03.01", "303.04.01", "303.05.01"],
        no_control: ["303.04.01", "303.05.01", "303.06.01", "303.07.01"]
      },
      metallic: {
        with_control: ["304.03.00", "304.04.00", "304.05.00", "304.06.00"],
        no_control: ["304.05.00", "304.06.00", "304.07.00", "304.08.00"]
      }
    },
    "3": {
      modular: {
        with_control: ["301.02.00", "301.03.00", "301.04.00", "301.05.00"],
        no_control: ["301.07.00", "301.08.00", "301.09.00", "301.10.00"]
      },
      monolithic: {
        with_control: ["303.06.01", "303.07.01", "303.08.01", "303.09.01"],
        no_control: ["303.08.01", "303.09.01", "303.10.01", "303.11.01"]
      },
      metallic: {
        with_control: ["304.07.00", "304.08.00", "304.09.00", "304.10.00"],
        no_control: ["304.09.00", "304.10.00", "304.11.00", "304.12.00"]
      }
    },
    "4": {
      modular: {
        with_control: ["301.06.00", "301.07.00", "301.08.00", "301.09.00"],
        no_control: ["301.11.00", "301.12.00", "301.13.00", "301.14.00"]
      },
      monolithic: {
        with_control: ["303.10.01", "303.11.01", "303.12.01"],
        no_control: ["303.12.01", "303.13.01", "303.14.01"]
      },
      metallic: {
        with_control: ["304.11.00", "304.12.00", "304.13.00"],
        no_control: ["304.13.00", "304.14.00"]
      }
    },
    "5": {
      modular: {
        with_control: ["301.10.00", "301.11.00", "301.12.00", "301.13.00", "301.14.00"],
        no_control: ["301.15.00", "301.16.00"]
      },
      monolithic: {
        with_control: ["303.13.01", "303.14.01"],
        no_control: []
      },
      metallic: {
        with_control: ["304.14.00"],
        no_control: []
      }
    },
    "6": {
      modular: {
        with_control: ["301.15.00", "301.16.00"],
        no_control: []
      },
      monolithic: {
        with_control: [],
        no_control: []
      },
      metallic: {
        with_control: [],
        no_control: []
      }
    }
  };